import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Home from './pages/home';
import Footer from './pages/footer';
import Navbar from './pages/navigation';
import TechPov from './pages/TechPov';
import AboutMe from './pages/aboutMe';
import Contact from './pages/contact';
function Main() {
  return (
    <div className="app-container">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/VivekSharma/tech-pov" element={<TechPov />} />
          <Route path="/VivekSharma/tech-pov" element={<TechPov />} />

          <Route path="/VivekSharma/about-me" element={<AboutMe />} />

          <Route path="/VivekSharma/lets-connect" element={<Contact />} />

        </Routes>
        <Footer />
        <Analytics />
      </BrowserRouter>
    </div>
  );
}

export default Main;
